//Types
export const Types = {
  LIST_DIRECTORY: "LIST_DIRECTORY",
  CREATE_DIRECTORY: "CREATE_DIRECTORY",
  RENAME_DIRECTORY: "RENAME_DIRECTORY",
  DELETE_DIRECTORY: "DELETE_DIRECTORY",
  UPLOAD_FILE: "UPLOAD_FILE",
  SET_LOADING: "SET_LOADING_FILE_SYSTEM",
}

//Reducer
const initialState = {
  directory: null,

  loading: false,
}

const FileSystem = (state = initialState, action) => {
  switch (action.type) {
    case Types.LIST_DIRECTORY:
      return {
        ...state,
        directory: action.payload,
        loading: false,
      }
    case Types.CREATE_DIRECTORY:
      return {
        ...state,
        directory: action.payload,
        loading: false,
      }
    case Types.RENAME_DIRECTORY:
      return {
        ...state,
        directory: action.payload,
        loading: false,
      }
    case Types.DELETE_DIRECTORY:
      return {
        ...state,
        directory: action.payload,
        loading: false,
      }
    case Types.UPLOAD_FILE:
      return {
        ...state,
				directory: action.payload,
        loading: false,
      }
    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      }

    default:
      return state;
  }
}

export default FileSystem;
